<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="p-3 2xl:p-10">
          <div class="flex space-x-4 my-4">
            <button
              class="px-4 py-2 rounded-xl text-xs font-semibold focus:outline-none border"
              :class="
                tab === 'assignment'
                  ? 'bg-blues text-white border-blue-600'
                  : 'bg-gray-100 text-black border-gray-300 hover:bg-blue-100 hover:border-blue-400'
              "
              @click="triggerPage('assignment')"
            >
              Assignment
            </button>

            <button
              class="px-4 py-2 rounded-xl text-xs font-semibold focus:outline-none border"
              :class="
                tab === 'assessment'
                  ? 'bg-blues text-white border-blue-600'
                  : 'bg-gray-100 text-black border-gray-300 hover:bg-blue-100 hover:border-blue-400'
              "
              @click="triggerPage('assessment')"
            >
              Assessment
            </button>
          </div>

          <div
            class="w-full bg-[#edf8ff] flex justify-center gap-5 items-center px-2 py-2 lg:px-8 rounded-md"
            v-if="response_message"
          >
            <h2 class="text-blues text-center">
              {{ response_message }}
            </h2>
            <router-link
              :to="{ name: 'DownloadHistory' }"
              class="text-blue-600 text-xs underline font-bold"
            >
              Download History
            </router-link>
          </div>

          <!-- ASSIGNMENT TAB -->
          <div v-if="tab === 'assignment'" class="space-y-4">
            <div class="p-4 flex flex-col gap-5">
              <div
                class="flex justify-between items-center flex-wrap md:flex-nowrap gap-4"
              >
                <h1 class="text-lg font-semibold text-gray-800">
                  Assignment ({{ assignmentCount }})
                </h1>
                <div class="flex gap-4 flex-wrap md:flex-nowrap">
                  <div class="relative w-full md:max-w-80">
                    <div
                      class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    </div>
                    <input
                      type="text"
                      v-model="search_list"
                      @input="getassignment(1)"
                      placeholder="Search..."
                      class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    />
                    <button
                      v-if="search_list"
                      @click="AssignclearSearch"
                      class="absolute inset-y-0 right-0 pr-3 flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-400 hover:text-gray-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                  <button
                    @click="assignmentdownload()"
                    :disabled="assignments.length === 0"
                    :class="[
                      assignments.length > 0
                        ? 'bg-blues hover:bg-blue-700 cursor-pointer text-white'
                        : 'bg-gray-200 cursor-not-allowed text-gray-500',
                    ]"
                    class="md:w-auto justify-center rounded-2xl py-2 px-5 flex items-center gap-2 transition-all duration-200"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                      />
                    </svg>
                    <p class="text-sm">Download</p>
                  </button>
                </div>
              </div>

              <div
                class="overflow-x-auto rounded-lg shadow border border-gray-200"
              >
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-100 text-blues whitespace-nowrap">
                    <tr class="text-left text-sm">
                      <th class="px-4 py-3 border-r text-center">S.No</th>
                      <th class="px-4 py-3 border-r">Assignment Title</th>
                      <th class="px-4 py-3 border-r text-center">
                        Total User Count
                      </th>
                      <th class="px-4 py-3 border-r text-center">
                        Complete User Count
                      </th>
                      <th class="px-4 py-3 border-r text-center">Download</th>
                      <th class="px-4 py-3 border-r">Created Date</th>
                      <th class="px-4 py-3">Due Date</th>
                    </tr>
                  </thead>

                  <!-- LOADING -->
                  <tbody v-if="assignmentLoading" class="h-[300px]">
                    <tr>
                      <td colspan="7" class="text-center py-8">
                        <div class="flex justify-center items-center">
                          <img
                            src="@/assets/newd/loading.gif"
                            alt=""
                            class="h-10"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>

                  <!-- DATA -->
                  <tbody
                    v-else-if="assignments.length > 0"
                    class="divide-y divide-gray-100 text-sm whitespace-nowrap"
                  >
                    <tr
                      v-for="(assignment, index) in assignments"
                      :key="index"
                      class="hover:bg-gray-50 transition-colors"
                    >
                      <td
                        class="px-4 py-3 border-r font-medium text-gray-800 text-center"
                      >
                        {{ (currentPage - 1) * pageSize + index + 1 }}
                      </td>
                      <td class="px-4 py-3 border-r min-w-[300px] md:w-[400px]">
                        <div class="whitespace-normal break-words line-clamp-2">
                          <router-link
                            :to="{
                              name: 'AssignmentGrade',
                              params: {
                                assignment_id: assignment.id,
                                assignment_title: assignment.title,
                              },
                            }"
                            class="text-blue-600 hover:text-blue-800 transition-colors"
                          >
                            {{ assignment.title }}
                          </router-link>
                        </div>
                      </td>
                      <td
                        class="px-4 py-3 border-r text-center text-gray-700 font-semibold"
                      >
                        {{ assignment.student_count || 0 }}
                      </td>
                      <td
                        class="px-4 py-3 border-r text-center text-gray-700 font-semibold"
                      >
                        {{ assignment.completed_count || 0 }}
                      </td>
                      <td class="px-4 py-3 border-r text-center cursor-pointer">
                        <div
                          class="inline-block text-blue-600 hover:text-blue-800 transition-colors"
                          @click="Assdownload(assignment.id)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 mx-auto"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                            />
                          </svg>
                        </div>
                      </td>
                      <td class="px-4 py-3 border-r text-gray-600">
                        {{ formatDate(assignment.created_at) }}
                      </td>
                      <td class="px-4 py-3 text-gray-600">
                        {{ assignment.duedate }}
                      </td>
                    </tr>
                  </tbody>

                  <!-- NO DATA -->
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center py-8 text-gray-600">
                        No Data Found
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                v-if="Assignment_count >= 11"
                class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
              >
                <div
                  class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
                >
                  <span class="flex md:hidden">Rows per page:</span>
                  <select
                    v-model="pageSize"
                    @change="BookPageSizeChange"
                    class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </select>
                </div>
                <div class="flex justify-center">
                  <Pagination
                    :totalPages="totalPages"
                    ref="paginationRef"
                    @page-changed="getassignment"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- ASSESSMENT TAB -->
          <div v-else class="space-y-4">
            <div class="p-4 flex flex-col gap-5">
              <div
                class="flex justify-between items-center flex-wrap md:flex-nowrap gap-4"
              >
                <h1 class="text-lg font-semibold text-gray-800">
                  Assessment ({{ assessmentCount }})
                </h1>
                <div class="flex gap-4 flex-wrap md:flex-nowrap">
                  <div class="relative w-full md:max-w-80">
                    <div
                      class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    </div>
                    <input
                      type="text"
                      v-model="searching"
                      @input="getassessment(1)"
                      placeholder="Search..."
                      class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    />
                    <button
                      v-if="searching"
                      @click="clearSearch"
                      class="absolute inset-y-0 right-0 pr-3 flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-400 hover:text-gray-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                  <button
                    @click="assessmentdownload()"
                    :disabled="assessments.length === 0"
                    :class="[
                      assessments.length > 0
                        ? 'bg-blues hover:bg-blue-700 cursor-pointer text-white'
                        : 'bg-gray-100 cursor-not-allowed text-gray-500',
                    ]"
                    class="md:w-auto justify-center rounded-2xl py-2 px-5 flex items-center gap-2 transition-all duration-200"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                      />
                    </svg>
                    <p class="text-sm">Download</p>
                  </button>
                </div>
              </div>

              <div
                class="overflow-x-auto rounded-lg shadow border border-gray-200"
              >
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-100 text-blues whitespace-nowrap">
                    <tr class="text-left text-sm">
                      <th class="px-4 py-3 border-r text-center">S.No</th>
                      <th class="px-4 py-3 border-r">Quizs Title</th>
                      <th class="px-4 py-3 border-r text-center">
                        Total User Count
                      </th>
                      <th class="px-4 py-3 border-r text-center">
                        Complete User Count
                      </th>
                      <th class="px-4 py-3 border-r text-center">Download</th>
                      <th class="px-4 py-3">Created Date</th>
                    </tr>
                  </thead>

                  <!-- LOADING -->
                  <tbody v-if="assessmentLoading" class="h-[300px]">
                    <tr>
                      <td colspan="7" class="text-center py-8">
                        <div class="flex justify-center items-center">
                          <img
                            src="@/assets/newd/loading.gif"
                            alt=""
                            class="h-10"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>

                  <!-- DATA -->
                  <tbody
                    v-else-if="assessments.length > 0"
                    class="divide-y divide-gray-100 text-sm whitespace-nowrap"
                  >
                    <tr
                      v-for="(assessment, index) in assessments"
                      :key="index"
                      class="hover:bg-gray-50 transition-colors"
                    >
                      <td
                        class="px-4 py-3 border-r text-center font-medium text-gray-800"
                      >
                        {{ (currentPage1 - 1) * pageSize1 + index + 1 }}
                      </td>
                      <td
                        class="px-4 py-3 border-r max-w-[500px] 2xl:w-[500px] text-wrap break-words"
                      >
                        <router-link
                          :to="{
                            name: 'AssessmentMark',
                            params: {
                              assessment_id: assessment.id,
                              assessment_title: assessment.name,
                            },
                          }"
                          class="text-blue-600 cursor-pointer"
                        >
                          {{ assessment.name || "Na" }}
                        </router-link>
                      </td>
                      <td class="px-4 py-3 border-r text-center text-gray-700">
                        {{ assessment.student_count || 0 }}
                      </td>
                      <td class="px-4 py-3 border-r text-center text-gray-700">                        {{ assessment.completed_count || 0 }}
                      </td>
                      <td
                        class="px-4 py-3 border-r text-blue-600 text-center cursor-pointer"
                      >
                        <div
                        href="#"
                          class="inline-block hover:text-blue-800"
                          @click="Assessdownload(assessment.id)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 mx-auto"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                            />
                          </svg>
                        </div>
                      </td>
                      <td class="px-4 py-2 text-gray-600">
                        {{ formatDate(assessment.timestamp) }}
                      </td>
                    </tr>
                  </tbody>

                  <!-- NO DATA -->
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center py-8 text-gray-600">
                        No Data Found
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                v-if="Assessment_count >= 11"
                class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
              >
                <div
                  class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
                >
                  <span class="flex md:hidden">Rows per page:</span>
                  <select
                    v-model="pageSize1"
                    @change="AssessmentPageSizeChange"
                    class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </select>
                </div>
                <div class="flex justify-center">
                  <Pagination
                    :totalPages="totalPages1"
                    ref="paginationRef1"
                    @page-changed="getassessment"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    Pagination,
  },
  data() {
    return {
      userSelectList: [],
      messages: { text: "", type: "null" },
      assignmentLoading: false,
      assessmentLoading: false,
      pageSize: 10,
      pageSize1: 10,
      currentPage: 1,
      totalPages: 1,
      Assignment_count: 0,
      Assessment_count: 0,
      tab: "assignment",
      assignments: [],
      assessments: [],
      assignmentCount: 0,
      assessmentCount: 0,
      totalPages1: 1,
      currentPage1: 1,
      search_list: "",
      searching: "",
      response_message: "",
    };
  },

  async created() {
    await this.getassignment(1);
    await this.getassessment(1);
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
    const fromTab = this.$route.query.fromTab;
    if (fromTab === "assignment" || fromTab === "assessment") {
      this.setTab(fromTab);
    }
  },

  methods: {
    AssignclearSearch() {
      this.search_list = "";
      this.getassignment(1);
    },
    clearSearch() {
      this.searching = "";
      this.getassessment(1);
    },
    setTab(view) {
      this.tab = view;
    },
    triggerPage(view) {
      this.setTab(view);
      this.$router.replace({ query: { ...this.$route.query, fromTab: view } });
      this.$nextTick(() => {
        if (view === "assignment" && this.$refs.paginationRef) {
          this.$refs.paginationRef.changePage(this.currentPage);
        } else if (view === "assessment" && this.$refs.paginationRef1) {
          this.$refs.paginationRef1.changePage(this.currentPage1);
        }
      });
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    },
    BookPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getassignment(1);
    },
    AssessmentPageSizeChange() {
      this.currentPage1 = 1;
      if (this.$refs.paginationRef1) {
        this.$refs.paginationRef1.currentPage = 1;
      }
      this.getassessment(1);
    },

    async getassignment(page) {
      this.assignmentLoading = true;
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/student_assignment_drade/?Key=${this.userInfo.token_key}&page=${page}&course_id__id=${this.course_id}&search=${this.search_list}&page_size=${this.pageSize}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.totalPages = response.data.data?.total_page;
            this.Assignment_count = response.data.data?.total;
            this.assignments = response.data.data?.data?.data || [];
            this.assignmentCount = response.data.data?.total || 0;
          } else {
            this.assignments = [];
            this.assignmentCount = 0;
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          this.assignments = [];
          this.assignmentCount = 0;
        })
        .finally(() => {
          setTimeout(() => {
            this.assignmentLoading = false;
          }, 1000);
        });
    },

    async getassessment(page) {
      this.assessmentLoading = true;
      this.currentPage1 = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/coursequize/grade/?Key=${this.userInfo.token_key}&page=${page}&course__id=${this.course_id}&search=${this.searching}&page_size=${this.pageSize1}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.totalPages1 = response.data.data?.total_page;
            this.Assessment_count = response.data.data?.total;
            this.assessments = response.data.data?.data?.data || [];
            this.assessmentCount = response.data.data?.total || 0;
          } else {
            this.assessments = [];
            this.assessmentCount = 0;
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          this.assessments = [];
          this.assessmentCount = 0;
        })
        .finally(() => {
          setTimeout(() => {
            this.assessmentLoading = false;
          }, 1000);
        });
    },

    async Assdownload(id) {
      window.location.href = `${process.env.VUE_APP_API}/student_assignment_drade/detail/?Key=${this.userInfo.token_key}&assignment_id=${id}&download=True&verify_status=accepted`;
    },
    async Assessdownload(id) {
      window.location.href = `${process.env.VUE_APP_API}/coursequize/taker/list/?Key=${this.userInfo.token_key}&completed=true&quiz__id=${id}&download=True`;
    },
    async assignmentdownload() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/assignments/download/all/?course_id=${this.course_id}&Key=${this.userInfo.token_key}`,
        )
        .then((resp) => {
          if (resp) {
            this.response_message =
              "Your file is ready to download go to download history page";
            setTimeout(() => {
              this.response_message = "";
            }, 5000);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async assessmentdownload() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/assessment/download/all/?course_id=${this.course_id}&Key=${this.userInfo.token_key}`,
        )
        .then((resp) => {
          if (resp) {
            this.response_message =
              "Your file is ready to download go to download history page";
            setTimeout(() => {
              this.response_message = "";
            }, 5000);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
